import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { initializeApp } from 'firebase/app';
import { captureError } from 'utils/sentry';

// Configuración de Firebase
const firebaseConfig = {
	apiKey: 'AIzaSyC46Bfdol9UpXiN5Brd4PGrpqiBfZscPJ8',
	authDomain: 'stellar-fx-444302-f2.firebaseapp.com',
	projectId: 'stellar-fx-444302-f2',
	storageBucket: 'stellar-fx-444302-f2.firebasestorage.app',
	messagingSenderId: '923697762592',
	appId: '1:923697762592:web:158ab092f0b139fdd6c745',
	measurementId: 'G-RGN2KQ32KL',
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

/**
 * Función legacy - subir solo imagen original
 * @deprecated Usar subirImagenConThumbnails en su lugar
 */
export const subirImagenAFirebase = async (file) => {
	try {
		const storageRef = ref(storage, `productos/${file.name}`);
		await uploadBytes(storageRef, file);
		return await getDownloadURL(storageRef);
	} catch (error) {
		captureError(error, {
			tags: {
				error_source: 'firebase_storage',
				operation: 'subirImagenAFirebase',
			},
			extra: {
				fileName: file?.name,
				fileType: file?.type,
				fileSize: file?.size,
			},
		});
		throw error;
	}
};

/**
 * Sube imagen original y devuelve URLs esperadas para thumbnail/full.
 * Las versiones optimizadas se generan en Firebase Cloud Functions.
 *
 * @param {File} file - Archivo de imagen seleccionado por el usuario
 * @returns {Object} URLs de las 3 versiones: { original, thumbnail, full }
 */
export const subirImagenConThumbnails = async (file) => {
	try {
		const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
		const webpFileName = `${fileNameWithoutExt}.webp`;
		const bucketName = firebaseConfig.storageBucket;
		const encodedWebpFileName = encodeURIComponent(webpFileName);

		// 1. Subir imagen original (dispara Cloud Function para generar thumbnail/full)
		const originalRef = ref(storage, `productos/${file.name}`);
		await uploadBytes(originalRef, file);
		const originalUrl = await getDownloadURL(originalRef);

		// 2. Devolver URLs públicas donde la Cloud Function guarda las versiones procesadas
		const thumbnailUrl = `https://storage.googleapis.com/${bucketName}/thumbnails/${encodedWebpFileName}`;
		const fullUrl = `https://storage.googleapis.com/${bucketName}/full/${encodedWebpFileName}`;

		// Retornar las 3 URLs
		return {
			original: originalUrl,
			thumbnail: thumbnailUrl,
			full: fullUrl,
		};
	} catch (error) {
		captureError(error, {
			tags: {
				error_source: 'firebase_storage',
				operation: 'subirImagenConThumbnails',
			},
			extra: {
				fileName: file?.name,
				fileType: file?.type,
				fileSize: file?.size,
			},
		});
		console.error('Error al procesar y subir imágenes:', error);
		throw new Error('Error al procesar las imágenes. Por favor, intente de nuevo.');
	}
};
